import React from 'react'
import { styled } from 'linaria/react'
// import Minus from '../../../svg/Minus.svg'
// import Plus from '../../../svg/Plus.svg'
import ArrowBtn from  '../../../svg/ArrowBtn.svg'
import { ChatBubbleQuestion } from 'iconoir-react'
import { generateUniqueId } from '../../Core/Util/Helpers'

const Container = styled.div`
   background-color: white;
`

const AccordionPanel = styled.div`
   overflow: hidden;

   .accordion-item {
      border-radius: 0;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-width: 2px;
      font-family: var(--font-grotesk-regular);
   }

   .accordion-collapse {
      transition: all 0.5s ease;
   }

   .accordion-title {
      font-weight: 700;
   }

   .accordion-sub-title {
      font-weight: 500;
   }

   .accordion-item:first-of-type {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
   }

   .accordion-item:last-of-type {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom: 0;
   }

   .accordion-button {
      font-size: 1.5rem;
      font-family: var(--font-industry);
      font-weight: 700;
      padding-left: 0;
      padding-right: 0;
   }

   .accordion-button:focus {
      box-shadow: none;
   }

   .accordion-button::after {
      width: 32px;
      height: 32px;
      background-image: url(${ArrowBtn});
      background-size: cover;
      transform: rotate(0deg);
      transition: transform 0.5s ease;
   }

   .accordion-button:not(.collapsed)::after {
      width: 32px;
      height: 32px;
      background-image: url(${ArrowBtn});
      transform: rotate(-180deg);
      transition: transform 0.5s ease;
   }

   .accordion-body {
   }

   .accordion-body ol,
   ul {
      padding: revert;
      margin: revert;
      list-style: revert;
   }

   .accordion-button:not(.collapsed) {
      background-color: unset;
      color: var(--color-black);
      box-shadow: none;
   }


   //    @media (min-width: 768px) {
   //       .accordion-button{
   //       font-size: 1.5rem;
   //       }
   //    }
`

export const ProductAccordion = ({ title, subTitle, icon, children, isOpen }) => {
   //    const GenerateStructureData = () => {
   //       let FAQStructureData = {
   //          "@context": "https://schema.org",
   //          "@type": "FAQPage",
   //          "mainEntity": []
   //       }

   //       for (const FAQItem of props?.children) {
   //          let FAQStructureQuestion = {
   //             "@type": "Question"
   //          }
   //          FAQStructureQuestion.name = FAQItem?.question
   //          FAQStructureQuestion.acceptedAnswer = {
   //             "@type": "Answer"
   //          }
   //          FAQStructureQuestion.acceptedAnswer.text = FAQItem?.answer
   //          FAQStructureData.mainEntity.push(FAQStructureQuestion)
   //       }

   //       return FAQStructureData;
   //    }

   // const activatePanel = event => {
   //    event.currentTarget.classList.toggle('active')
   //    var panel = event.currentTarget.nextElementSibling
   //    if (panel.style.maxHeight) {
   //       panel.style.maxHeight = null
   //    } else {
   //       panel.style.maxHeight = panel.scrollHeight + 'px'
   //    }
   // }

   const uniqueId = generateUniqueId()

   return (
      <Container>
         <AccordionPanel id="accordionPanel">
            <div className="accordion-item">
               <h2
                  className="accordion-header"
                  id={`panelsStayOpen-headingOne-${uniqueId}`}
               >
                  <button
                     className={`accordion-button ${
                        isOpen ? 'show' : 'collapsed'
                     }`}
                     type="button"
                     data-bs-toggle="collapse"
                     data-bs-target={`#panelsStayOpen-collapseOne-${uniqueId}`}
                     aria-expanded="true"
                     aria-controls="panelsStayOpen-collapseOne"
                  >
                     <div className="d-flex gap-2 align-items-center">
                        {icon}
                        <span style={{ display: 'flex', flexWrap: 'wrap', columnGap: '0.25em'  }}>
                        {/* <span style={{ display: 'flex', flexDirection: "column"  }}> */}
                           <span>{title}</span>
                           {subTitle && <span className="accordion-sub-title">{subTitle}</span>}
                        </span>
                     </div>
                  </button>
               </h2>
               <div
                  id={`panelsStayOpen-collapseOne-${uniqueId}`}
                  className={`accordion-collapse ${
                     isOpen ? 'show' : 'collapse'
                  }`}
                  aria-labelledby="panelsStayOpen-headingOne"
               >
                  <div className="accordion-body pt-0 mt-3">{children}</div>
               </div>
            </div>
         </AccordionPanel>
      </Container>
   )
}
